module.exports = {
  "userObjectTz": {
    "name": "User Object Time Zone",
    "class": "usage",
    "properties": {
      "action": {
        "type": [
          "hover",
          "open",
          "cancel",
          "save"
        ]
      },
      "tz": {
        "type": "string"
      },
      "autoUpdate": {
        "type": [
          "true",
          "false",
          "unknown"
        ]
      }
    },
    "namespace": "settingsui",
    "version": "1"
  },
  "permissionsPanelClick": {
    "name": "Permissions Panel Click",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "SAVE",
          "CANCEL",
          "BACK",
          "NEXT"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": "string",
        "isOptional": false
      },
      "permissionLevel": {
        "type": [
          "VIEW",
          "EDIT",
          "NONE"
        ],
        "isOptional": false
      },
      "accessClassification": {
        "type": [
          "PRIVATE",
          "EVERYONE",
          "SPECIFIC"
        ],
        "isOptional": false
      },
      "numOfAssignedEntities": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "settingsui",
    "version": "1"
  }
};